import axios from "axios";
import { getToken, logout } from "./auth";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_EXPORTADORES_URL
});
api.interceptors.request.use(async config => {
    const access_token = getToken();
    if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        const access_token = getToken();
        if (error.response && error.response.status === 401 && access_token) {
            logout();
            return;
        }
        return Promise.reject(error);
    }
);

export default api;